import dayjs from 'dayjs';
import {LocaleUtils} from '@/utils/locale-utils';

export const DateUtils = {
  mixins: [
    LocaleUtils
  ],
  methods: {
    formatDate (date, format, fallback = '-') {
      format = format || 'LL';

      const parsedDate = dayjs(date);
      if(parsedDate.isValid()) {
        if (format === 'fromNow') {
          return this.formatFromNow(date);
        }
        return parsedDate.format(format);
      }
      return fallback;
    },

    formatYearMonth (year, month, fallback = '- -') {
      const parsedDate = dayjs(year+'-'+month+'-01');
      if(parsedDate.isValid()) {
        return parsedDate.format('MMMM YYYY');
      }
      return fallback;
    },

    formatFromNow (date) {
      let dayJsDate = dayjs(date);
      if (dayJsDate.isYesterday()) {
        return `${this.trans('general.yesterday')}, ${dayJsDate.format('LT')}`;
      }
      return dayJsDate.fromNow();
    },

    getMonthNameByIndex(monthIndex) {
      return dayjs('2020-'+monthIndex+'-1').format('MMMM')
    },

    getIsoDateString(date) {
      return dayjs(date).format('YYYY-MM-DD')
    },

    getEndOfNextMonthString() {
      return this.getIsoDateString(dayjs().add(1,'month').endOf('month'));
    },

    /**
     * @param {any} date
     * @param {Number} year
     * @param {Number} month
     */
    isDateInYearAndMonth(date, year, month) {
      const parsedDate = dayjs(date);
      if(parsedDate.month() + 1 !== month) {
        return false;
      }
      if(parsedDate.year() !== year) {
        return false;
      }
      return true;
    }
  }
};
